import { ChevronDown, Star } from "lucide-react";
import { useEffect, useState } from "react";
import * as api from "../api";
import { PLATFORM_COLORS, parseRatings } from "../constants";

export default function TopSection({ onCardClick }) {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("movie");
  const [movies, setMovies] = useState([]);
  const [series, setSeries] = useState([]);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const all = await api.getContent();
        setRecent(all.slice(0, 5));
      } catch {}
    })();
  }, []);

  useEffect(() => {
    if (!open) return;
    (async () => {
      try {
        // ✅ FIX: sin filtro de status — el Top 3 incluye TODO el contenido
        // sort: "rating" ya aplica ORDER BY imdb_rating DESC en el backend
        const all = await api.getContent({ sort: "rating", status: "pending" });
        const m = all
          .filter((i) => i.type === "movie" && i.imdb_rating)
          .slice(0, 3);
        const s = all
          .filter((i) => i.type === "series" && i.imdb_rating)
          .slice(0, 3);
        setMovies(m);
        setSeries(s);
      } catch {}
    })();
    // ✅ FIX: dependencia solo en `open` — recarga cada vez que se abre
  }, [open]);

  const items = tab === "movie" ? movies : series;
  const medals = ["🥇", "🥈", "🥉"];

  return (
    <div className="mb-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <button
          onClick={() => setOpen(!open)}
          className="flex items-center gap-2 text-lg font-bold text-white hover:text-cinema-accent transition-colors group"
        >
          <span>🏆 Top 3</span>
          <ChevronDown
            size={20}
            className={`text-steel-400 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
          />
        </button>
        <div className="flex items-center gap-2">
          <span className="text-xs uppercase tracking-wide text-steel-400">Añadido recientemente</span>
          <div className="flex items-center gap-1">
            {recent.length > 0 ? (
              recent.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  onClick={() => onCardClick(item)}
                  className="group rounded-md border border-cinema-border overflow-hidden hover:border-cinema-accent/50 transition-colors"
                  title={item.title}
                  aria-label={`Abrir ${item.title}`}
                >
                  {item.poster ? (
                    <img
                      src={item.poster}
                      alt={item.title}
                      className="w-8 h-12 object-cover"
                      loading="lazy"
                    />
                  ) : (
                    <div className="w-8 h-12 bg-steel-700 flex items-center justify-center text-xs">
                      {item.type === "series" ? "📺" : "🎬"}
                    </div>
                  )}
                </button>
              ))
            ) : (
              <div className="text-steel-500 text-xs">Sin datos</div>
            )}
          </div>
        </div>
      </div>

      {open && (
        <div className="mt-3 animate-fade-in">
          <div className="flex gap-1 mb-3 bg-cinema-card rounded-xl p-1 w-fit">
            {["movie", "series"].map((t) => (
              <button
                key={t}
                onClick={() => setTab(t)}
                className={`px-4 py-1.5 rounded-lg text-sm font-medium transition-all ${tab === t ? "tab-active text-white" : "text-steel-300 hover:text-white"}`}
              >
                {t === "movie" ? "🎬 Películas" : "📺 Series"}
              </button>
            ))}
          </div>

          {items.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {items.map((item, i) => {
                const rt = parseRatings(item.ratings_json);
                return (
                  <div
                    key={item.id}
                    onClick={() => onCardClick(item)}
                    className="flex items-center gap-3 bg-cinema-card border border-cinema-border rounded-xl p-3 hover:border-cinema-accent/30 cursor-pointer transition-all card-glow"
                  >
                    <span className="text-2xl">{medals[i]}</span>
                    {item.poster ? (
                      <img
                        src={item.poster}
                        alt=""
                        className="w-12 h-16 object-cover rounded-lg"
                      />
                    ) : (
                      <div className="w-12 h-16 bg-steel-700 rounded-lg flex items-center justify-center text-xl">
                        {item.type === "series" ? "📺" : "🎬"}
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <h4 className="text-white font-medium text-sm truncate">
                        {item.title}
                      </h4>
                      <div className="flex items-center gap-2 mt-1 flex-wrap">
                        <span className="text-steel-400 text-xs">
                          {item.year}
                        </span>
                        {item.imdb_rating && (
                          <span className="flex items-center gap-0.5 text-yellow-400 text-xs font-medium">
                            <Star size={10} fill="currentColor" />
                            {item.imdb_rating}
                          </span>
                        )}
                        {rt.rt && <span className="text-xs">🍅{rt.rt}</span>}
                      </div>
                      {item.platform && (
                        <span
                          className="inline-block mt-1 px-1.5 py-0.5 rounded text-[10px] font-medium text-white platform-badge"
                          style={{
                            background:
                              PLATFORM_COLORS[item.platform] || "#333",
                          }}
                        >
                          {item.platform}
                        </span>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <p className="text-steel-400 text-sm">
              No hay contenido con puntuación aún.
            </p>
          )}
        </div>
      )}
    </div>
  );
}
